import React, { Component } from 'react';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { trans } from '../../../../localization';
import RestaurantWalletTable from './components/RestaurantWalletTable';

class RestaurantWalletModal extends Component {
  render() {
    const {
      walletRestaurant,
      closeUserWalletRestaurant,
      removeRestaurantUserWallet,
      openAddRestaurantUserWallet,
      changeActivePage,
      changePageSize,
    } = this.props;
    const {
      isOpenDialog,
      table,
      airpayStoreId,
    } = walletRestaurant;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          className="user-wallet-restaurant-modal"
          onRequestClose={closeUserWalletRestaurant}
        >
          <ModalHeader>
            <div className="check-res-header">
              {trans('merchant_wallet_restaurant')}
              <button
                type="button"
                className="btn btn-red"
                onClick={openAddRestaurantUserWallet}
              >
                {trans('merchant_wallet_add_restaurant')}
              </button>
            </div>
          </ModalHeader>
          <ModalBody>
            <RestaurantWalletTable
              table={table}
              removeRestaurantUserWallet={removeRestaurantUserWallet}
              airpayStoreId={airpayStoreId}
              changeActivePage={changeActivePage}
              changePageSize={changePageSize}
            />
          </ModalBody>
          <ModalAction>
            <ModalButton type="cancel" onClick={closeUserWalletRestaurant}>
              {trans('common_close')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

export default RestaurantWalletModal;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/RestaurantWallet/RestaurantWalletModal.jsx